<template>
    <div>
        <section>
            <div class="container">
                <h2>
                    Works - 作品紹介
                </h2>
            </div>
        </section>
        <div class="container">
            <router-view v-bind:data="myData"></router-view>
        </div>
    </div>
</template>
<script>
    import myData from '../../../static/data.json'
    export default {
        data () {
            return {
                myData: myData
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layouts/Works.vue